module.exports = "<md-card class=\"mt-double mat-card\">\n  <iframe *ngIf=\"entityIdDetails.entityId\" style=\"height: 540px\" [src]=\"safeUrl()\" class=\"iframeStyle\"></iframe>\n</md-card>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/entity-new-caf/entity-new-caf.component.html
// module id = 2296
// module chunks = 0